import { DcmJsDatasetWrapper } from './dcmJsWrapper';
import { DicomBase } from './dicomBase';
import { Modality } from './modality';

export class DicomPlan extends DicomBase {
    /**
     * 	(300C,0060) Referenced Structure Set Sequence Attribute
     */
    public readonly referencedRtStructureSetUid: string;

    constructor(
        sopUid: string,
        public readonly rtPlanLabel: string,
        referencedRtStructureSetUid: string,
        dataset: DcmJsDatasetWrapper
    ) {
        super(sopUid, Modality.RTPLAN, dataset);
        this.referencedRtStructureSetUid = referencedRtStructureSetUid;
    }
}
